'use strict';

var es7 = require('./node_modules/es-abstract/es7.js');
var index$1 = require('../has/src/index.js');
var index = require('../function-bind/index.js');

var ES = es7;
var has = index$1;
var bind = index;
var isEnumerable = bind.call(Function.call, Object.prototype.propertyIsEnumerable);

var implementation = function entries(O) {
	var obj = ES.RequireObjectCoercible(O);
	var entrys = [];
	for (var key in obj) {
		if (has(obj, key) && isEnumerable(obj, key)) {
			entrys.push([key, obj[key]]);
		}
	}
	return entrys;
};

module.exports = implementation;
